export default "__VITE_ASSET__DwScQybc__"